var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRegular = function SvgChevronRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 10.896a.77.77 0 0 1-.571-.254L1.592 5.697a.72.72 0 0 1-.216-.52c0-.413.324-.737.736-.737.203 0 .388.082.534.222L7 9.125l4.355-4.463c.14-.14.33-.222.533-.222.406 0 .73.324.73.736q0 .313-.21.52l-4.837 4.946a.76.76 0 0 1-.571.254"
  })));
};
export default SvgChevronRegular;